import React from 'react'

const FypIdeas = () => {
  return (
    <div>FypIdeas</div>
  )
}

export default FypIdeas